import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgProgress } from '@ngx-progressbar/core';
import { formatDate } from '@telerik/kendo-intl';
import { ToastrService } from 'ngx-toastr';
import { APIOperableComponent } from '../../../../shared/components/api-operable/api-operable.component';
import { AuthService } from '../../../security/service/auth.service';
import { FormSubmissionListColumnsModel } from '../../model/formSubmission-list-columns.model';
import { FormSubmission } from '../../model/formSubmission.model';
import { SurveyManagementService } from '../../service/survey-management.service';

@Component({
  selector: 'survey-form-submission',
  templateUrl:
    './console/app-js/modules/surveyManagement/components/survey-form-submission/survey-form-submission.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./survey-form-submission.component.scss']
})
export class SurveyFormSubmissionComponent extends APIOperableComponent {
  columns = FormSubmissionListColumnsModel;
  formsData: Array<FormSubmission> = [];
  @Input('formId') formId: number = this.activatedRoute.snapshot.params[
    'formId'
  ];
  @Input('formName') formName: string = this.activatedRoute.snapshot.params[
    'formName'
  ];

  constructor(
    progressService: NgProgress,
    toastr: ToastrService,
    authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private surveyManagementService: SurveyManagementService
  ) {
    super(progressService, toastr, authService);
    this.loadingIndicator = false;
    this.getFormSubmissionsData();
  }

  getFormSubmissionsData(): void {
    this.surveyManagementService.getFormSubmissions(this.formId).subscribe(
      result => {
        this.loadingIndicator = true;
        if (result) {
          this.formsData = result.sort(
            (a: FormSubmission, b: FormSubmission) =>
              new Date(b.submissionDate).getTime() -
              new Date(a.submissionDate).getTime()
          );
          this.loadFormsData();
        }
        this.loadingIndicator = false;
      },
      error => {
        console.error(error);
        this.loadingIndicator = false;
        this.formsData = [];
      }
    );
  }

  private loadFormsData(): void {
    if (this.formsData !== undefined && this.formsData.length !== 0) {
      this.formsData.forEach(obj => {
        obj.submissionDate = `<span>${
          obj.submissionDate != null
            ? formatDate(new Date(obj.submissionDate), 'MM/dd/yyyy')
            : ''
        }</span>`;
        obj.surveyPdfKey = !obj.surveyPdfKey
          ? `<a class="cellLink"><i class="fa fa-download fa-lg" aria-hidden="true"></i></a>`
          : '';
      });
    } else {
      this.formsData = [];
    }
  }
}
